import { useEffect, useRef, useState } from 'react';

import _ from 'lodash';

export default function useVisibility(
  ref,
  options = { rootMargin: '0px' },
  { once = true, isDeferred = false },
) {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [isTimeoutEnded, setIsTimeoutEnd] = useState(!isDeferred);
  const observerRef = useRef(null);
  const timerRef = useRef(null);

  // TODO: IntersectionObserver and dnd are not correctly work with chrome, using setTimeout is resolve that
  if (isDeferred) {
    timerRef.current = setTimeout(() => {
      setIsTimeoutEnd(true);
    }, 0);
  }

  useEffect(() => {
    if (!isTimeoutEnded) {
      return;
    }

    // A batch can hold several entries for the target (e.g. a fast scroll in and out);
    // the last one is its current state.
    observerRef.current = new window.IntersectionObserver(entries => {
      const entry = _.last(entries);

      if (isIntersecting !== entry.isIntersecting) {
        setIsIntersecting(entry.isIntersecting);
      }

      if (entry.target && entry.isIntersecting && once) {
        observerRef.current.unobserve(entry.target);
      }
    }, options);

    const nodeRef = ref.current;

    if (nodeRef) {
      observerRef.current.observe(nodeRef);

      return () => {
        observerRef.current.unobserve(nodeRef);
        clearTimeout(timerRef.current);
      };
    }
  }, [ref, options, once, isTimeoutEnded, isIntersecting]);

  return isIntersecting;
}
